<script lang="ts" setup>
import { computed } from 'vue'

import { usePageStore } from '../../../../../stores/page'
import NativeTeaserItem from '../../../../../components/ui/teaser/NativeTeaserItem.vue'
import { isNativeTeaserItem } from '../../../../../components/ui/teaser/teaser-group-constants'
import TeaserGroupItem from './TeaserGroupItem.vue'

import type { TeaserGroupProps } from '../../../../../components/ui/teaser/use-teaser-groups'

const props = withDefaults(defineProps<TeaserGroupProps>(), {
  variant: 'teaser-group-single-big',
  adaAutoNative: false
})

const hasMultipleTeasers = computed(() => (props.teasers?.length ?? 0) > 1)

const headingType = computed(() => {
  return usePageStore().pageData?.pageMeta?.pageType === 'structureterm' ? 'h2' : 'div'
})

const teaserGroupStyleClasses = computed(() => {
  return {
    '[&:has(+[data-ad-slot-name])]:mb-0': props.variant === 'teaser-group-single-small',
    'flex flex-col sm:flex-row sm:gap-x-5 gap-y-5 w-full [&>*]:basis-1/2': props.variant === 'teaser-group-double-big',
    'flex w-full flex-col gap-y-5 sm:flex-row sm:gap-x-5': props.variant === 'teaser-group-double',
    'w-full sm:flex-1': props.variant === 'teaser-group-triple-first',
    'flex flex-col gap-5 sm:basis-1/3': props.variant === 'teaser-group-triple-other',
    'flex flex-col gap-5 sm:flex-row': props.variant === 'teaser-group-quadruple',
    'sm:basis-[calc(25%-20px)]': props.adaAutoNative && props.variant === 'teaser-group-quadruple'
  }
})
</script>

<template>
  <div :class="teaserGroupStyleClasses"
       :data-ems="adaAutoNative ? 'ems-native-teasercontainer' : null">
    <template v-for="teaser in teasers">
      <NativeTeaserItem v-if="isNativeTeaserItem(teaser)"
                        :key="`native-teaser-${teaser.fallback.assetId}`"
                        :native-teaser-index="teaser.nativeTeaserIndex">
        <TeaserGroupItem :item-data="teaser.fallback"
                         :variant="props.variant"
                         :ada-auto-native="props.adaAutoNative"
                         :heading-type="headingType"
                         :has-multiple-teasers="hasMultipleTeasers"
                         :is-native-item-content="true" />
      </NativeTeaserItem>
      <TeaserGroupItem v-else-if="teaser"
                       :key="`teaser-${teaser.assetId}`"
                       :item-data="teaser"
                       :variant="props.variant"
                       :ada-auto-native="props.adaAutoNative"
                       :heading-type="headingType"
                       :has-multiple-teasers="hasMultipleTeasers"
                       :is-native-item-content="false" />
    </template>
  </div>
</template>
